// extracted by mini-css-extract-plugin
module.exports = {"Textarea__textarea":"medkit__Textarea__Textarea__textarea","Textarea__textarea_withLabel":"medkit__Textarea__Textarea__textarea_withLabel"};